/**
 * =========================================
 * GLOBAL TILE REGISTRY
 * =========================================
 * Combines tiles from all platforms
 * LOGIC ONLY — no UI
 */

import { adminTileRegistry } from "../../platforms/admin/tiles/tileRegistry";
import { campusTileRegistry } from "../../platforms/campus/tiles/tileRegistry";
import { eduTileRegistry } from "../../platforms/edu/tiles/tileRegistry";

export const tileRegistry = {
  /**
   * =========================================
   * SYSTEM TILES
   * =========================================
   */

  home: {
    id: "home",
    system: true,
  },

  store: {
    id: "store",
    noUninstall: true,
  },

  /**
   * =========================================
   * PLATFORM TILES
   * =========================================
   */

  ...campusTileRegistry,
  ...eduTileRegistry,
  ...adminTileRegistry,
};
